import React from "react";
import ServiceDetailsHeroArea from "./ServiceDetailsHeroArea";
import ServiceDetailsArea from "./ServiceDetailsArea";

const ServiceDetails = () => {
  return (
    <>
      <ServiceDetailsHeroArea />
      <ServiceDetailsArea />
    </>
  );
};

export default ServiceDetails;
